import ApiService from "../../../../commons/services/ApiService";
import CompanyAPI from "../../../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class ClubPlanAPI {
  URI_V1 = "/v1/club/plans";

  getCompanyId() {
    const cm = companyAPI.getCompanyManagment();
    return cm?.id;
  }

  /**
   * Criar novo clube
   */
  create = async (payload: any) => {
    const companyId = this.getCompanyId();

    return await apiService.post(
      `${this.URI_V1}?companyId=${companyId}`,
      {
        ...payload,
        companyId, // backend também espera no body
      }
    );
  };

  update = async (id: any, payload: any) => {
    const companyId = this.getCompanyId();

    return await apiService.put(
      `${this.URI_V1}/${id}?companyId=${companyId}`,
      {
        ...payload,
        companyId, // backend também espera no body
      }
    );
  };


  /**
   * Buscar por ID
   */
  getById = async (id: any) => {
    const companyId = this.getCompanyId();

    return await apiService.get(
      `${this.URI_V1}/${id}?companyId=${companyId}`
    );
  };

  /**
   * Listar clubes da empresa
   */
  list = async () => {
    const companyId = this.getCompanyId();

    return await apiService.get(
      `${this.URI_V1}?companyId=${companyId}`
    );
  };

  /**
   * Soft delete
   */
  delete = async (id: any) => {
    const companyId = this.getCompanyId();

    return await apiService.post(
      `${this.URI_V1}/${id}/delete?companyId=${companyId}`,
      null
    );
  };

  /**
   * Ativar / Desativar
   */
  toggleActive = async (id: any) => {
    const companyId = this.getCompanyId();

    return await apiService.post(
      `${this.URI_V1}/${id}/toggle-active?companyId=${companyId}`,
      null
    );
  };
}
